export default __webpack_public_path__ + "static/media/mandate-homepage-banner.43975d25.jpg";